import React from "react";
export class UiBuildertoolBar extends React.Component<any, any> {
    render() {
        return <ul style={{ display: "table" }} className="k-widget k-reset k-header k-menu k-menu-horizontal innoKMenuStrip">
            {this.props.children}
        </ul>
    }
};